export default {
    install(Vue) {
        //初始化数据表头方法
        /*
        * 参数说明：
        *       1.parentFlag:
        *           含义:任务单发起标识
        *           参考值示例:copyadd\change,分别指复制新增\变更.(注:可能包含其他的状态值)
        *       2.parentTaskbillid:
        *           含义:任务单id
        *       3.parentBillId:
        *           含义:单据id
        *       4.parentProcdefId:
        *           含义:流程id
        *       5.parentNodeName:
        *           含义:节点名
        *       6.nid:
        *           含义:节点id
        * 返回值说明：
        *       1）状态 type：S/E 2) msg 3）data
        *
        * */
        Vue.prototype.initLuckSheetHeader = async function (paramMap) {
                //1.从参数map中获取请求参数
                let parentFlag = paramMap.get('parentFlag');
                let parentTaskbillid = paramMap.get('parentTaskbillid');
                let parentBillId = paramMap.get('parentBillId');
                let parentProcdefId = paramMap.get('parentProcdefId');
                let parentNodeName = paramMap.get('parentNodeName');
                let nid = paramMap.get('nid');
                //2.返回值 1）状态 type：S/E 2) msg 3）data
                let rMap = new Map;
                rMap.set("type","S");
                rMap.set("msg","");
                //初始化表头
                let that = this;
                let pkid = '-1';
                if (parentTaskbillid) {
                    if (parentFlag != 'copyadd'  && parentFlag != 'change' ) {
                        pkid = '' + parentTaskbillid;
                    }
                }
                await this.$ajax
                    .post('/jhBillPropertiesTb/queryList/' + pkid + '/' + parentFlag, {
                        billid: parentBillId,
                        parentProcdefId: parentProcdefId,
                        nodename: parentNodeName,
                        nodeid:nid
                    })
                    .then(function (response) {
                        if (response.data.code == 200) {
                            let metaDatas = response.data.obj[1][parentBillId];
                            rMap.set("data",metaDatas);
                        } else {
                            rMap.set("type","E");
                            rMap.set("msg",response.data.msg);
                        }
                    });
            return rMap;
        }
        //获取时间
        Vue.prototype.getNowTime =  function () {
            var date = new Date();
            var seperator1 = '-';
            var seperator2 = ':';
            //以下代码依次是获取当前时间的年月日时分秒
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var strDate = date.getDate();
            var minute = date.getMinutes();
            var hour = date.getHours();
            var second = date.getSeconds();
            //固定时间格式
            if (month >= 1 && month <= 9) {
                month = '0' + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = '0' + strDate;
            }
            if (hour >= 0 && hour <= 9) {
                hour = '0' + hour;
            }
            if (minute >= 0 && minute <= 9) {
                minute = '0' + minute;
            }
            if (second >= 0 && second <= 9) {
                second = '0' + second;
            }
            var currentdate = year + seperator1 + month + seperator1 + strDate
                + ' ' + hour + seperator2 + minute + seperator2 + second;
            return currentdate;
        }
        /**
         * ----------渲染luckySheet表头的方法----------
         * @param metaDataLists {Array}
         * @param metaDataLists.item {Object}
         * @param metaDataLists.item.jhBillPropertiesList {Array}
         *
             组合返回值
             1.cells
             2.propViewObj
             3.propIndex
             4.indexProp
             5.indexPropName
             6.propNameIndex
             7.viewObjs
         */
        Vue.prototype.dealLuckySheetHeader = function (paramMap){
            //1.从接收参数中解析出方法调用参数
            let metaDataLists = paramMap.get('metaDataLists');
            let parentFlag = paramMap.get('parentFlag');
            let propViewObj = paramMap.get('propViewObj');
            let propIndex = paramMap.get('propIndex');
            let indexProp = paramMap.get('indexProp');
            let indexPropName = paramMap.get('indexPropName');
            let propNameIndex = paramMap.get('propNameIndex');
            let viewObjs = paramMap.get('viewObjs');
            let projectCodeIndex = paramMap.get('projectCodeIndex');
            let operationCellNos = paramMap.get('operationCellNos');
            let billname = paramMap.get('billname');
            //2.定义返回信息
            let rMap = new Map;
            rMap.set("type","S");
            rMap.set("msg","");
            //3.定义本方法使用的临时变量
            let cells = [];
            let currCell = -1;
            let hbCurrCell = -1;
            let data = new Map;
            //4.业务逻辑
            {
                //4.1 遍历组合表头展示
                metaDataLists.forEach((item) => {
                    let currViewObj = {};
                    if(item.isshow == 'true'){
                        if (item.jhBillPropertiesList) {
                            item.jhBillPropertiesList.forEach((prop) => {
                                if(prop.isshow == 'true'){
                                    hbCurrCell++;
                                }
                            });
                        }
                        let cell = {c:currCell+1,cs:hbCurrCell};
                        cells.push(cell);
                        //第二行 视图名称行
                        if(currCell == -1){
                            luckysheet.setCellValue(1, 0, item.viewname);
                            luckysheet.setCellValue(1, 0, {ht: 0,bl:1 });//居中//加粗
                        }else{
                            luckysheet.setCellValue(1, currCell+1, item.viewname);
                            luckysheet.setCellValue(1, currCell+1, {ht: 0, bl:1});
                        }
                        if (item.jhBillPropertiesList) {
                            item.jhBillPropertiesList.forEach((prop) => {
                                if(prop.isshow == 'true'){
                                    this.$set(currViewObj,prop.byname,'');
                                    propViewObj.set(prop.byname,item.vbyname);
                                    currCell++;
                                    luckysheet.setCellValue(0, currCell, prop.byname);
                                    propIndex.set(prop.byname,currCell);//记录列索引
                                    indexProp.set(currCell,prop.byname);//记录列索引
                                    luckysheet.setCellValue(2, currCell, prop.name);
                                    indexPropName.set(currCell,prop.name);//记录列索引
                                    //自适应表头宽度
                                    let str = prop.name;
                                    let strLength  =  str.replace(/[\u0391-\uFFE5]/g,"aa").length;   //先把中文替换成两个字节的英文，在计算长度
                                    let pp = {};
                                    pp[currCell] = (strLength*7)+10;
                                    luckysheet.setColumnWidth(pp);
                                    propNameIndex.set(prop.name,currCell);//记录列索引
                                    luckysheet.setCellValue(2, currCell, {tb: 2, ht: 0,bl:1});
                                    if (prop.isneed == 'true') {
                                        luckysheet.setCellValue(2, currCell, {fc: "#ff0000"});
                                    }
                                    //数据编制隐藏列（年度投资计划--特殊处理）
                                    if('年度投资计划'== billname && parentFlag != 'detail' && (prop.name == '今年计划调整-投资额' || prop.name == '今年计划调整-形象进度' || prop.name == '调整额' || prop.name == '调整类型' || prop.name == '调整原因')){
                                        luckysheet.hideColumn(currCell, currCell);
                                    }
                                    //扩充项目编码字段，隐藏
                                    if(prop.name == '项目编码' ){
                                        luckysheet.hideColumn(currCell, currCell);
                                        projectCodeIndex = currCell;
                                    }
                                    //记录无操作权限的列索引，并进行字段操作权限的控制。。。。。
                                    if(prop.isoperate != 'true'){
                                        operationCellNos.push(currCell);
                                    }
                                }

                            });
                        }
                    }
                    this.$set(viewObjs,item.vbyname,currViewObj);
                });
                //4.2 设置表头样式
                luckysheet.setRowHeight({1:46});//设置第二行高
                luckysheet.setRowHeight({2:39});//设置第二行高
                luckysheet.hideRow(0, 0);//隐藏第一行
                luckysheet.setHorizontalFrozen(true, { range: 'B3' });//设置冻结表头
            }
            data.set("cells",cells);
            data.set("propViewObj",propViewObj);
            data.set("propIndex",propIndex);
            data.set("indexProp",indexProp);
            data.set("indexPropName",indexPropName);
            data.set("propNameIndex",propNameIndex);
            data.set("viewObjs",viewObjs);
            data.set("projectCodeIndex",projectCodeIndex);
            data.set("operationCellNos",operationCellNos);
            rMap.set("data",data);
            return rMap;
        }
        /*
        * 查询要渲染的数据
        * @param 111
        * */
        Vue.prototype.queryTaskDataViewCom = async function (parentFlag,parentTaskbillid,childtaskbill,parentNodeName) {
            debugger
            let that = this;
            let allDatas = [];
            //组合进行返回的值
            //2.定义返回信息
            let data = new Map;
            let rMap = new Map;
            rMap.set('type','S');
            rMap.set('msg','');
            switch (parentFlag){
                case 'copyadd':
                    await that.$ajax
                        .post('/taskbillDataforviewTb/queryListByYearPlanOther', {taskbillid: parentTaskbillid,opflag:parentFlag})
                        .then(function (response){
                            if (response.data.code == 200) {
                                var datas = response.data.obj;
                                //遍历渲染数据
                                var dataNum = 0;
                                datas.forEach((item) => {
                                    dataNum++;
                                    childtaskbill = childtaskbill+item.taskbillid;
                                    if(dataNum < datas.length){
                                        childtaskbill += ",";
                                    }
                                    var currRowData = JSON.parse(item.datajson);
                                    allDatas.push(currRowData);
                                });
                            } else {
                                rMap.set('type','E');
                                rMap.set('msg',response.data.msg)
                            }
                        });
                    break;
                case 'detail':
                    await that.$ajax
                        .post('/taskbillDataforviewTb/queryListByYearPlan', {taskbillid: parentTaskbillid,nodename:''})
                        .then(function (response) {
                            if (response.data.code == 200) {
                                var datas = response.data.obj;
                                //遍历渲染数据
                                var dataNum = 0;
                                datas.forEach((item) => {
                                    dataNum++;
                                    childtaskbill = childtaskbill+item.taskbillid;
                                    if(dataNum < datas.length){
                                        childtaskbill += ",";
                                    }
                                    var currRowData = JSON.parse(item.datajson);
                                    allDatas.push(currRowData);
                                });
                            } else {
                                rMap.set('type','E');
                                rMap.set('msg',response.data.msg);
                            }
                        });
                    break;
                case 'deal':
                    await that.$ajax
                        .post('/taskbillDataforviewTb/queryListByYearPlan', {taskbillid: parentTaskbillid,nodename:parentNodeName })
                        .then(function (response) {
                            if (response.data.code == 200) {
                                var datas = response.data.obj;
                                //遍历渲染数据
                                var dataNum = 0;
                                datas.forEach((item) => {
                                    dataNum++;
                                    childtaskbill = childtaskbill+item.taskbillid;
                                    if(dataNum < datas.length){
                                        childtaskbill += ",";
                                    }
                                    var currRowData = JSON.parse(item.datajson);
                                    allDatas.push(currRowData);
                                });
                            } else {
                                rMap.set('type','E');
                                rMap.set('msg',response.data.msg)
                            }
                        });
                    break;
            }
            //组合返回的数据
            if('S' == (rMap.get('type'))){
                data.set('childtaskbill',childtaskbill);
                data.set('allDatas',allDatas);
                rMap.set('data',data);
            }
            return rMap;
        }
        //获取辅助信息的方法
        Vue.prototype.getAuxiliaryExplanationCom = function (auxiliaryexplanation,parentBillId,parentBillName,parentTaskbillid) {
            let information = JSON.parse(sessionStorage.getItem('userinfo'));
            let applicant = information.name;
            auxiliaryexplanation.starter = information.name;
            auxiliaryexplanation.starterid = information.id;
            auxiliaryexplanation.taskbillid = parentTaskbillid;
            auxiliaryexplanation.startdept = information.orgid;
            auxiliaryexplanation.startdeptname = information.infoOrg.label;
            auxiliaryexplanation.billid = parentBillId;
            auxiliaryexplanation.billname = parentBillName;
            auxiliaryexplanation.starttime = this.getNowTime();
            return [auxiliaryexplanation,applicant];
        }

        Vue.prototype.chatatABC = function (n) {
            var orda = 'a'.charCodeAt(0);
            var ordz = 'z'.charCodeAt(0);
            var len = ordz - orda + 1;
            var s = "";
            while (n >= 0) {
                s = String.fromCharCode(n % len + orda) + s;
                n = Math.floor(n / len) - 1;
            }
            return s.toUpperCase();
        }

        Vue.prototype.setSum = function (month,propnameIndex,currRow,sumIndex,allVal){
            for(let i = 0;i < month.length;i++){
                let val = this.chatatABC(propnameIndex.get(month[i]))+currRow;
                if(allVal == ''){
                    allVal += val;
                }else{
                    allVal = allVal+','+val;
                }
            }
            luckysheet.setCellValue(currRow-1, sumIndex,{f: "=sum("+allVal+")", bg:"#FF0000"});
            let cellIndex1 =  propnameIndex.get(month[0]);
            let cellVal1 = luckysheet.getCellValue(currRow-1,cellIndex1);
            luckysheet.setCellValue(currRow-1,cellIndex1,cellVal1);
        }

        //数据渲染
        Vue.prototype.renderTaskBillData = function (initDatas,metaDatas,propnameIndex,propIndex){
            var rrow = 2;
            for (let i = 0; i < initDatas.length; i++) {
                debugger
                let parentBillName = initDatas[i].billname;
                rrow++;
                var currRowData = initDatas[i];
                //遍历视图
                metaDatas.forEach((item) => {
                    var currViewData = currRowData[item.vbyname];
                    //遍历属性
                    for(var key in currViewData){
                        //待办赋值操作
                        //通过key获取列索引
                        var currCellIndex = propIndex.get(key);
                        luckysheet.setCellValue(rrow, currCellIndex, currViewData[key]);
                    }
                });
                if(parentBillName == '合同付款计划'){
                    let month = ['1月付款计划(万元)','2月付款计划(万元)','3月付款计划(万元)','4月付款计划(万元)','5月付款计划(万元)','6月付款计划(万元)','7月付款计划(万元)','8月付款计划(万元)','9月付款计划(万元)','10月付款计划(万元)','11月付款计划(万元)','12月付款计划(万元)'];
                    let sumIndex = propnameIndex.get('合计计划付款金额(万元)');
                    let currRow = rrow+1;
                    this.setSum(month,propnameIndex,currRow,sumIndex,'');
                }else if(parentBillName == '项目付款计划'){
                    let month = ['1月付款计划','2月付款计划','3月付款计划','4月付款计划','5月付款计划','6月付款计划','7月付款计划','8月付款计划','9月付款计划','10月付款计划','11月付款计划','12月付款计划'];
                    let sumIndex = propnameIndex.get('合计金额');
                    let currRow = rrow+1;
                    this.setSum(month,propnameIndex,currRow,sumIndex,'');
                }

            }
        }
        //时间格式设置
        Vue.prototype.setExcelTime = function (timeList){
            for(var i = 0;i < timeList.length;i++){
                luckysheet.setCellValue(3,timeList[i], {
                    "ct": {
                        "fa": "yyyy-MM-dd",
                        "t": "d"
                    }
                });
            }
        }

        //保存excel配置
        Vue.prototype.saveExcelConfig = function (hbconfig,operationCellNos,masterList){
            //4.合并第二行（视图名称行，相同视图的行进行合并操作）
            let conf = luckysheet.getConfig();
            if(conf.merge == undefined){
                conf.merge = {};
            }
            for(var i = 0; i < hbconfig.length;i++){
                var c = hbconfig[i].c;
                var cs = hbconfig[i].cs;
                this.$set(conf.merge, "1_"+c, {r:1,c:c,rs:1,cs:cs});
            }
            //5.无法编辑行号
            if(conf.jheditrow == undefined){
                conf.jheditrow = [0,1,2];
            }
            //获取到无权限的列索引
            if(operationCellNos.length > 0){
                conf.jheditcell = operationCellNos;
            }
            //主数据弹出框配置
            conf.master = masterList;
            luckysheet.setConfig(conf);
        }


        Vue.prototype.getPropIndexs = function (metaDatas,cellNum){
            let masterMap = new Map;
            let masterList = [];
            let bdMap = new Map;
            let bdList = [];
            let timeList = [];
            let xmNameINdex = -1;
            metaDatas.forEach((item) => {
                if(item.isshow == 'true'){
                    if (item.jhBillPropertiesList) {
                        item.jhBillPropertiesList.forEach((prop) => {
                            if(prop.isshow == 'true'){
                                cellNum++;
                                if(prop.style == 4 || prop.style == 5){
                                    if(prop.style == 5){
                                        if(prop.master != null && prop.master != '' && prop.master != undefined){
                                            masterMap.set(cellNum-1,prop.master);
                                            masterList.push(cellNum-1);
                                        }
                                    }else{
                                        //下拉框
                                        bdMap.set(cellNum-1,prop.reference);
                                        bdList.push(cellNum-1);
                                    }
                                }else if(prop.style == 3){//时间格式处理
                                    timeList.push(cellNum-1);
                                }
                                var currName = prop.name;
                                //记录项目名称索引
                                if(currName == "项目名称"){
                                    xmNameINdex=cellNum-1;
                                }
                            }
                        });
                    }
                }
            });
            return [masterMap,masterList,bdMap,bdList,timeList,xmNameINdex,cellNum];
        }

        Vue.prototype.submitTaskBill = async function (parentFlag,viewObjs,timeList,parentBillName,parentBillId,parentMbyname,parentProcdefId,
                                                 parentStatus,auxiliaryexplanation,parentTaskbillid,childtaskbill,parentNodeName,datas,propMap){
            let r = null;
            switch (parentFlag){
                case 'next'://提交下一级
                    var that = this;
                    let taskBillData = [];
                    for(var i = 3;i < datas.length;i++){
                        //当前行数据
                        var viewObjs = JSON.parse(JSON.stringify(viewObjs));
                        var currData = datas[i];
                        for(var j = 0;j < currData.length;j++){
                            //当前属性别名
                            var currPropByname = datas[0][j];
                            //获取视图别名
                            var currViewByname = propMap.get(currPropByname.v);
                            if(currData[j] != null){
                                var currVal = '';
                                if(timeList.indexOf(j) != -1){
                                    currVal = currData[j].m;
                                }else{
                                    currVal = currData[j].v;
                                }
                                var currView = viewObjs[currViewByname];
                                let yz = currData[j].yz;
                                if(yz != undefined){
                                    if(yz == false){
                                        let errorMsg = "第"+(i+1)+"行第"+(j+1)+"列填写的值”"+currVal+"“未通过验证！";
                                        return [false,errorMsg];
                                    }
                                }
                                this.$set(currView,currPropByname.v,currVal);
                                this.$set(viewObjs,currViewByname,currView);
                            }
                        }
                        this.$set(viewObjs,"billname",parentBillName);
                        this.$set(viewObjs,"billid",parentBillId);
                        this.$set(viewObjs,"mbyname",parentMbyname);
                        this.$set(viewObjs,"parentProcdefId",parentProcdefId);
                        this.$set(viewObjs,"codestr","");
                        this.$set(viewObjs,"idx",1);
                        this.$set(viewObjs,"parentSysId","");
                        this.$set(viewObjs,"parentSysIdAll","");
                        this.$set(viewObjs,"taskbillid","");
                        this.$set(viewObjs,"CombinedDataMap",[]);
                        taskBillData.push(viewObjs);
                    }
                    var comit = 'add';
                    if(parentStatus != '1'){
                        comit = 'change';
                    }
                    paramObj = {
                        taskBillData: JSON.stringify(taskBillData),
                        auxiliaryexplanation: JSON.stringify(auxiliaryexplanation),
                        commitType:comit,
                        taskbillid: parentTaskbillid,
                        childtaskbillid:childtaskbill,
                        opinionInput: auxiliaryexplanation.intro,
                        nodename: parentNodeName
                    };
                    await this.$ajax.post('/infoTaskbillTb/submitNextYearPlanTb', paramObj)
                        .then((res) => {
                            if (res.data.code == 200) {
                                // 请求成功之后执行的内容
                                let okMsg = '提交下一级操作成功';
                                r = [true,okMsg];
                            } else {
                                let errMsg = res.data.msg;
                                r = [false,errMsg];
                            }
                        });
                    break;
                case 'rollback':
                    paramObj = {
                        taskbillid: this.parentTaskbillid,
                        opinionInput: this.opinionInput
                    };
                    this.$ajax({
                        url: '/infoTaskbill/rollbackup',// 请求的 url 地址
                        method: 'post', // 请求方式
                        params: paramObj// 传递的参数
                    }).then((res) => {
                        if (res.data.code == 200) {
                            // 请求成功之后执行的内容
                            that.$notify.success('驳回成功');
                            that.delnextlevel1 = false;
                            that.saveOpinion('danger', '驳回');
                            //清除数据
                            that.$emit('closeDraawer');
                        } else {
                            that.$notify.error(res.data.msg);
                        }
                    });
                    break;
                case 'suspend':
                    var that = this;
                    var paramObj = {
                        taskbillid: this.parentTaskbillid
                    };
                    this.$ajax({
                        url: '/infoTaskbill/suspend',// 请求的 url 地址
                        method: 'post', // 请求方式
                        params: paramObj// 传递的参数
                    }).then((res) => {
                        if (res.data.code == 200) {
                            // 请求成功之后执行的内容
                            that.$notify.success('终止成功');
                            that.saveOpinion('danger', '终止');
                            that.$emit('closeDraawer');
                        } else {
                            that.$notify.error(res.data.msg);
                        }
                    });
                    break;
            }
            return r;
        }
    }


}

